import React from 'react';
import TextField from 'src/ui/library/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import NumberMask from './PercentageMask';
import InfoTooltip from 'src/ui/library/ContentParser/controls/Tooltip/InfoTooltip';
import DOMPurify from 'dompurify';
import intl from 'react-intl-universal';
import iconTransform from 'src/helpers/iconTransform.js';
import transformDisplayText from 'src/helpers/transformDisplayText';
import { DEFAULT_CONTROL_FONT_SIZES } from 'src/constants/constants';
import ErrorIcon from '@mui/icons-material/Error';

const renderPercentageControl = props => {
  const errorText = intl.get('questionnaire.showModal.alertMessageForNumber');

  return (
    <TextField
      InputProps={{
        inputComponent: NumberMask,
        endAdornment: <InputAdornment position="start">%</InputAdornment>,
      }}
      useEllipsisLabel={true}
      ellipsisAdjustIcon={false}
      {...props}
      hasError={props.hasError}
      errorText={errorText}
    />
  );
};

export default props => {
  const errorText = intl.get('questionnaire.showModal.alertMessageForNumber');
  const { align, icon, hasParentTable, showText, description, ...otherProps } = props;
  const alignClass = align === 'R' ? 'right-align' : align === 'C' ? 'center-align' : 'left-align';
  let finalText = '';
  finalText = transformDisplayText(description, DEFAULT_CONTROL_FONT_SIZES[otherProps.origControlTypeName], otherProps.increaseFontSize);
  finalText = showText === true ? finalText : '';

  return (
    <React.Fragment>
      <div className={`control-text flex-column ${alignClass}`}>
        {finalText && !hasParentTable ? (
          <div className={`control-wrapper ${align === 'C' ? 'justifyCenter' : ''}`}>
            {icon && <div className={'control-icons control-icons-inline'}></div>}
            <div className={'control-icons-inline-controls label-field'}>
              <span component="legend" className="control-label">
                {finalText}
              </span>
            </div>
          </div>
        ) : null}

        {
          <div className={`control-wrapper ${align === 'C' ? 'justifyCenter' : ''}`}>
            {icon && <div className={'control-icons control-icons-inline'}>{iconTransform(icon)}</div>}
            <div className={`control-icons-inline-controls ${props.helpText ? 'with-tooltip' : ''} ${icon ? 'with-icon' : ''}`}>
              {props && props.helpText ? (
                <React.Fragment>
                  <InfoTooltip toolTipText={props.helpText} labelText={renderPercentageControl(props)} className="percentage-tooltip" />
                  {props.hasError && (
                    <p className="textfield-error-text"> <ErrorIcon sx={{ verticalAlign:'bottom', fontSize: 14 }}/> <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(errorText) }} /></p>
                  )}
                </React.Fragment>
              ) : (
                renderPercentageControl(props)
              )}
            </div>
          </div>
        }
      </div>
    </React.Fragment>
  );
};
